export enum UWG4RegulationMode {
    NotSpecified = 0,
    Auto = 1,
    Manual = 2,
    Vacation = 3,
    Comfort = 4
}

export interface UWG4InternalStorage {
    name: string,
    serverIp: string,
    serverPort: number,
    setPointInCelsius: number,
    currentTemperatureInCelsius: number,
    serialNumber: string,
    email: string,
    softwareVersion: string,
    minSetPointInCelsius: number,
    maxSetPointInCelsius: number,
    regulationMode: UWG4RegulationMode,
    vacationEndDate: Date,
    comfortEndDate: Date,
    zipCode: string,
    city: string,
    isLoggedOn: boolean,
    useDaylightSavingsTime: boolean,
    distributorId: number,
    isConnectedToServer: boolean,
    isConnectingToServer: boolean,
    isConfirmed: boolean
}

export interface UWG4Thermostat {
    ID: number,
    thermostatID: string,
    internalStorage: UWG4InternalStorage,
    currentState: string,
    workspaceID: number;
}